/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {MenuItem} from "@mui/material";
import ArgosSelect from "../../../../../components/Form/Select/ArgosSelect";
import {MRT_Cell, MRT_ColumnDef} from "material-react-table";
import {ObjectPropertiesInput, objectPropertiesInput, ObjectPropertyRow} from "../../constants";
import {useEffect, useState} from "react";
import {useHasWriteAccess} from "../../../../../../redux/ducks/AccessControl/accessControlHelpers";
import {toast} from "react-hot-toast";
import {ArgosTableSimple} from "../../../../../components/Table/ArgosTableSimple";


interface IObjectPropertiesProps {
  temperatureArray: number[]
  handleTempChange: any
  baselineData: any
  isDialogOpen: any
  gmid: string
  configIndex: any
  setIsPublicConfig: any
  newObjectName: string
}

const ObjectProperties = (props: IObjectPropertiesProps) => {
  const hasWriteAccess = useHasWriteAccess();
  const [tableData, setTableData] = useState<any>([]);

  useEffect(() => {
    populateTable();
  }, [props])

  const populateTable = () => {
    let _tableData: ObjectPropertyRow[] = []
    let data = props?.baselineData;
    objectPropertiesInput.forEach((element: ObjectPropertiesInput) => {
      let _tableDataObject: ObjectPropertyRow = {
        objectPropertyName: element.label,
        unit: element.unit,
        objectPropertyValue: data?.[element.key],
        objectPropertyKey: element.key
      }
      _tableData.push(_tableDataObject)
    })
    setTableData(_tableData)
  }


  /**
   * Table cell input validation
   */
  const [validationErrors, setValidationErrors] = useState<any>({});
  function helperSetValidationErrors(newVal: string, cell: any, message: string) {
    setValidationErrors({
      ...validationErrors,
      [cell.id]: message
    })
    toast.error(message,
      {
        style: {
          marginTop: "300px"
        },
        duration: 3000
      })
  }
  const validateInput = (newVal: string, cell: any) => {
    let newValnum = Number(newVal)
    if (isNaN(newValnum)) {
      helperSetValidationErrors(newVal, cell, `Not valid value, must be a number`)
      return false
    }
    return true
  }
  const getCommonEditTextFieldProps = (cell: MRT_Cell<ObjectPropertyRow>): MRT_ColumnDef<ObjectPropertyRow>['muiEditTextFieldProps'] => {
    return {
      error: !!validationErrors[cell.id],
      helperText: validationErrors[cell.id],
      onKeyDown: (e) => {
        if (e.code == "Tab") {
          e.stopPropagation()
          e.preventDefault()
        }
      },
      onBlur: (event) => {
        if (cell.row.original.objectPropertyKey == "firingMode") { // TODO: Implement updating firing mode value in state when it is changed.
          const isValid = validateInput(event.target.value, cell);
          if (isValid) {
            delete validationErrors[cell.id];
          }
        }
      },
    };
  }

  const objectPropertiesRowColumns: MRT_ColumnDef<ObjectPropertyRow>[] = [
    {
      header: "Name",
      accessorKey: "objectPropertyName",
      enableEditing: false,
    },
    {
      header: "Value",
      accessorKey: "objectPropertyValue",
      enableEditing: true,
      minSize: 700,
      muiEditTextFieldProps: ({cell}) => ({
        ...getCommonEditTextFieldProps(cell),
        disabled: !hasWriteAccess || props?.baselineData?.objectCategory === "Baseline"
      }),
      Cell: ({cell}) => {
        let _objectPropertyKey: string = cell.row.original.objectPropertyKey

        let dropdownValue: string = "";

        let menuItems: any[] = []

        let cellValue: any = cell.getValue()

        switch (_objectPropertyKey) {
          case "firingMode":
            cellValue = props.baselineData.firingMode
            console.log('baselineData', props.baselineData)
            break;
          case "objectName":
            menuItems = [props.baselineData.objectName]
            dropdownValue = props.baselineData.objectName
            break;
          case "objectProperties":
            if (props?.baselineData.objectCategory == "Baseline") {
              dropdownValue = props?.baselineData?.objectVariant;
              menuItems = ["Front Profile"]
            } else if (props?.baselineData.objectCategory != "Custom") {
              dropdownValue = props?.baselineData?.objectVariant;
              menuItems = ["Front Profile", "Side Profile", "Rear Profile"]
            } else {
              dropdownValue = "";
              menuItems = []
            }
            break;
          case "objectCategory":
            dropdownValue = props?.baselineData?.objectCategory;
            menuItems = ["Baseline"]
            break;
          case "temperature":
            dropdownValue = props?.baselineData?.temperature
            menuItems = props?.temperatureArray
            break;
          default:
            menuItems = []
        }

        if (!(_objectPropertyKey === "objectVersion" || _objectPropertyKey === "firingMode")) {
          return (
            <ArgosSelect
              value={dropdownValue}
              onChange={(e: any) => {
                if (cell.row.original.objectPropertyKey == "objectName") {

                } else if (cell.row.original.objectPropertyKey === 'temperature') {
                  const numberValue = Number(e.target.value)
                  props?.handleTempChange(numberValue)
                }
              }}
            >
              {menuItems.map((item: any) => <MenuItem value={String(item)}>{item} </MenuItem>)}
            </ArgosSelect>)
        } else {

          const value: any = (typeof cellValue === 'number' || cellValue?.length > 0) ? cellValue : 'N/A';
          return <div>{value}</div>
        }
      }
    },
    {
      header: "Unit",
      accessorKey: "unit",
      enableEditing: false,
    },
  ]
  return (
    <div style={{padding: "5px"}}>
      <ArgosTableSimple
        columns={objectPropertiesRowColumns}
        data={tableData}

        editDisplayMode="cell"
        enableEditing
        enableBottomToolbar={false}
        muiTableProps={{
          sx: {
            tableLayout: 'fixed',
          },
        }}
        initialState={{density: 'compact'}}
      />
    </div>)
}
export default ObjectProperties;